module.exports = __webpack_public_path__ + "static/media/orbita-sydle-one.6fc300b1.svg";